module.exports = __webpack_public_path__ + "assets/img/about_culture3.b16932ac.png";